import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Button } from '@storable/canaveral-components';
import gql from 'graphql-tag';
import PageTitle from '../PageTitle';
import styles from './styles.scss';

const propTypes = {
  navigationPageIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func.isRequired,
  page: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {};

const NavigationPagesMenuItem = ({
  navigationPageIds,
  onClick,
  page,
}) => (
  <Menu.Item
    className={styles.item}
    componentClass="div"
  >
    <div className={styles.content}>
      <Button
        icon="add"
        label="Add page to navigation"
        context="bare"
        className={styles.button}
        disabled={navigationPageIds.includes(page.id)}
        onClick={() => onClick(page)}
      />
      <PageTitle
        page={page}
        className={styles.title}
      />
    </div>
  </Menu.Item>
);

NavigationPagesMenuItem.propTypes = propTypes;
NavigationPagesMenuItem.defaultProps = defaultProps;

NavigationPagesMenuItem.fragments = {
  page: gql`
    fragment NavigationPagesMenuItemPage on Page {
      id
      ...PageTitlePage
    }

    ${PageTitle.fragments.page}
  `,
};

export default NavigationPagesMenuItem;
